module.exports = __webpack_public_path__ + "static/media/investor.9303351e.png";